import validateDefaults from "../validateDefaults";
import $ from "jquery";

import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'

import Modal from 'bootstrap/js/dist/modal'

import { getCookie, setCookie } from '../helpers'


$.validator.addMethod('regexp', function (value, element, param) {
    return this.optional(element) || value.match(param);
});

$.validator.addMethod('custom_required', function (value, element, param) {
    // Check if dependency is met
    if (!this.depend(param, element)) {
        return "dependency-mismatch";
    }
    if (element.nodeName.toLowerCase() === "select") {

        // Could be an array for select-multiple or a string, both are fine this way
        let val = $(element).val();
        return val && val.length > 0;
    }
    if (this.checkable(element)) {
        return this.getLength(value, element) > 0;
    }
    return value !== undefined && value !== null && value.length > 0;
});

const creditFormModal = () => {

    const $credit__form = $('#credit__form');
    const $submit_credit_form = $('[data-submit-credit-form]');
    const $form__col = $('.form__col');
    let form_credit;

    const creditModal = new Modal('#creditModal');
    const successModal = new Modal('#successModal');


    if ($('.phone__input_md').length) {
        form_credit = $credit__form.validate({
            errorClass: "form__error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                credit__type: {required: true},
                credit__name: {required: true, maxlength: 255},
                credit__phone: {required: true, regexp: /(?:(\+373))(?:\s*\d){8}$/},
                terms__rules_credit: {custom_required: true},
            },
            ...validateDefaults
        });
    } else {
        form_credit = $credit__form.validate({
            errorClass: "form__error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                credit__type: {required: true},
                credit__name: {required: true, maxlength: 255},
                credit__phone: {required: true, regexp: /(?:(\+40))(?:\s*\d){9}$/},
                terms__rules_credit: {custom_required: true},
            },
            ...validateDefaults
        });
    }
    $submit_credit_form.on('click', function (e) {
        $submit_credit_form.addClass('button__loading');
        // let theLanguage = $('html').attr('lang')
        let formCredit = new FormData($credit__form[0]);

        setTimeout(function () {
            if (form_credit.form() != false) {
                $.ajax({
                    url: '/credit-order',
                    method: "POST",
                    cache: false,
                    data: formCredit,
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        if (data.status == true) {
                            //success
                            $submit_credit_form.removeClass('button__loading');
                            creditModal.hide();
                            successModal.show();
                            $credit__form[0].reset();
                            $form__col.removeClass('has-value');
                        }
                    },
                    error: function (data) {
                        //error
                        $submit_credit_form.removeClass('button__loading');
                        form_credit.form();
                    }
                });
            } else {
                $submit_credit_form.removeClass('button__loading');
                form_credit.form();
            }
        }, 1500);

    });
};

const requestFormModal = () => {

    const $request__form = $('#request__form');
    const $submit_request_form = $('[data-submit-request-form]');
    const $form__col = $('.form__col');
    let form_request;

    const requestModal = new Modal('#requestModal');
    const successModal = new Modal('#successModal');

    if ($('.phone__input_md').length) {
        form_request = $request__form.validate({
            errorClass: "form__error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                request__name: {required: true, maxlength: 255},
                request__phone: {required: true, regexp: /(?:(\+373))(?:\s*\d){8}$/},
                terms__rules_request: {custom_required: true},
            },
            ...validateDefaults
        });
    } else {
        form_request = $request__form.validate({
            errorClass: "form__error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                request__name: {required: true, maxlength: 255},
                request__phone: {required: true, regexp: /(?:(\+40))(?:\s*\d){9}$/},
                terms__rules_request: {custom_required: true},
            },
            ...validateDefaults
        });
    }

    $submit_request_form.on('click', function (e) {
        $submit_request_form.addClass('button__loading');
        // let theLanguage = $('html').attr('lang');
        let form = new FormData($request__form[0]);

        // console.log('requestModal', requestModal);

        setTimeout(function () {
            if (form_request.form() != false) {
                $.ajax({
                    url: '/individual-order',
                    method: "POST",
                    cache: false,
                    data: form,
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        if (data.status == true) {
                            //success
                            $submit_request_form.removeClass('button__loading');
                            // requestModal.hide();
                            requestModal.hide();
                            successModal.show();
                            $request__form[0].reset();
                            $form__col.removeClass('has-value');
                        }
                    },
                    error: function (data) {
                        //error
                        $submit_request_form.removeClass('button__loading');
                        form_request.form();
                    }
                });
            } else {
                $submit_request_form.removeClass('button__loading');
                form_request.form();
            }
        }, 1500);

    });
};


const deliveryFormModal = () => {

    const $submit_delivery_form = $('.button__delivery_submit');

    $submit_delivery_form.on('click', function (e) {

        $('.button__delivery').text($('[name="delivery__city"] option:selected').text())

        setCookie('delivery_date', $(".delivery_result_date_modal").data('date-delivery'), {expires: 15552000, path: '/'});
        setCookie('locality_name', $('[name="delivery__city"] option:selected').text(), {expires: 15552000, path: '/'});
        setCookie('id_countie', $('[name="delivery__region"]').val(), {expires: 15552000, path: '/'});
        setCookie('id_localitie', $('[name="delivery__city"]').val(), {expires: 15552000, path: '/'});
        setCookie('zone_price', $('[name="price_zone_'+ (parseInt($('[name="delivery__region"] option:selected').data('zone')) + 1)  +'"]').val(), {expires: 15552000, path: '/'});

        $(".product__delivery_result").removeClass("d-none");
    });
};

creditFormModal()
requestFormModal()
deliveryFormModal()
